export default __webpack_public_path__ + "static/media/img3.0f95511a.jpg";